export const entityResource = {
    ROLE: {
        NAME: 'roles',
    },
    USER: {
        NAME: 'users',
        SALES_API: 'users/sales',
    },
    GOODS: {
        NAME: 'goods',
        CATEGORIES_API: 'goods/categories',
        UPLOAD_URL: 'goods/upload',
        UPLOAD_API: 'goods/bulk',
    },
    STORE: {
        NAME: 'store',
        UNGENERATED_QR: 'store/ungenerated-qr',
        UPLOAD_URL: 'store/upload',
        UPLOAD_API: 'store/bulk',
    },
    PRICE: {
        NAME: 'price',
        UPLOAD_URL: 'price/upload',
        UPLOAD_API: 'price/bulk',
    },
    TARGET: {
        NAME: 'target',
        UPLOAD_URL: 'target/upload',
        UPLOAD_API: 'target/bulk',
    },
    SCHEDULE: {
        NAME: 'schedule',
        GENERATE: 'schedule/generate',
        BULK: 'schedule/bulk',
    },
    ORDER: {
        NAME: 'order',
    },
    ORDER_DETAIL: {
        NAME: 'order-detail',
    },
    SETTING: {
        NAME: 'settings',
    },
    PRIVACY_POLICY: {
        NAME: 'privacy-policy',
    },
};

export const orderStatus = [
    { id: 'PENDING', name: 'PENDING' },
    { id: 'INPROGRESS', name: 'INPROGRESS' },
    { id: 'COMPLETE', name: 'COMPLETE' },
    { id: 'CANCEL', name: 'CANCEL' },
    { id: 'SUCCESS', name: 'SUCCESS' },
    { id: 'PENDING_PAYMENT', name: 'PENDING_PAYMENT' },
];
